





































import { Component, Vue, Prop } from 'vue-property-decorator'
import { ITableHeaderColumn } from '@/types/interfaces/table-header-column'

@Component
export default class TableColumnPicker extends Vue {
  @Prop({ required: true, default: false }) columnSelectionMenu: boolean
  @Prop({ required: true, default: [] }) headers: ITableHeaderColumn[]
  @Prop({ required: false, default: '' }) area: string
}
